module.exports = __webpack_public_path__ + "img/40.27a0320d.jpg";